import './dev-telegram'
import { App } from './App'
import './styles/main.css?v=1'


// Initialize Lucide icons
import { createIcons, Home, Gift, Handshake, Star, ListChecks, Share2, Check, Trophy, ArrowLeft, Users, Copy, MessageCircle, Send, Smile, Calendar, Sticker, Package, ChevronLeft, ChevronRight, Camera, Store, UserCircle, Sparkles } from 'lucide'
createIcons({
  icons: {
    Home,
    Gift,
    Handshake,
    Star,
    ListChecks,
    Share2,
    Check,
    Trophy,
    ArrowLeft,
    Users,
    Copy,
    MessageCircle,
    Send,
    Smile,
    Calendar,
    Sticker,
    Package,
    ChevronLeft,
    ChevronRight,
    Camera,
    Store,
    UserCircle,
    Sparkles
  },
})

import { initTabBar } from './utils/tabbar'
initTabBar()

// Initialize the app
const app = new App()
app.initialize().catch(console.error)
